import { fontXSStyle, panelBaseStyle } from '@blocksuite/hive-shared/styles';
import { css } from 'lit';

export const renameStyles = css`
  ${panelBaseStyle('.hive-attachment-rename-container')}
  .hive-attachment-rename-container {
    position: relative;
    display: flex;
    align-items: center;
    width: 320px;
    gap: 12px;
    padding: 12px;
    z-index: var(--hive-z-index-popover);
  }

  .hive-attachment-rename-input-wrapper {
    display: flex;
    min-width: 280px;
    height: 30px;
    box-sizing: border-box;
    padding: 4px 10px;
    background: var(--hive-white-10);
    border-radius: 4px;
    border: 1px solid var(--hive-border-color);
  }

  .hive-attachment-rename-input-wrapper:focus-within {
    border-color: var(--hive-blue-700);
    box-shadow: var(--hive-active-shadow);
  }

  .hive-attachment-rename-input-wrapper input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    color: var(--hive-text-primary-color);
  }
  ${fontXSStyle('.hive-attachment-rename-input-wrapper input')}

  .hive-attachment-rename-input-wrapper input::placeholder {
    color: var(--hive-placeholder-color);
  }

  .hive-attachment-rename-extension {
    font-size: var(--hive-font-xs);
    color: var(--hive-text-secondary-color);
  }

  .hive-attachment-rename-overlay-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: var(--hive-z-index-popover);
  }
`;

export const styles = css`
  :host {
    z-index: 1;
  }
`;
